import React from "react";
import CaseListPage from "./CaseListPage";
import { approvedCasesConfig } from "./caseListConfig";

const IndexUserApprovedCases = () => (
  <CaseListPage config={ approvedCasesConfig } />
);

export default IndexUserApprovedCases;
